import { axiosInstance } from "api";
import Loading from "components/Loading";
import { useQuery } from "react-query";
import { useDispatch } from "react-redux";
import { setNewsModal } from "redux/reducers/newsModalReducer";

import useDeleteStyle from "hooks/useDeleteStyle";
import { useParams } from "react-router";
import Pagination from "../Pagination";
import {
  BottomContainer,
  ContentBox,
  ImgBox1,
  TextBox,
  TextBox2,
  TopContainer,
  TopFirstBox,
  TopImgBox,
  TopSecondBox,
  Wrapper,
} from "./style";

const Com2 = () => {
  const dispatch = useDispatch();
  const { page } = useParams();
  const {
    data: newsData,
    isSuccess,
    isLoading,
  } = useQuery(["newsEvent" + page], () => axiosInstance.get("/newsEvent/page?page=" + page + "&size=12"));

  const openNewsModal = (id) => {
    const selectedData = newsData.content.find((v) => v.id === id);
    dispatch(setNewsModal(selectedData));
  };

  // 날짜 포맷팅
  function leftPad(value) {
    if (value >= 10) {
      return value;
    }
    return `0${value}`;
  }
  /**
   *
   * @param {Date} source
   * @param {String} delimiter
   * @returns
   */
  function toStringByFormatting(source, delimiter = ".") {
    const year = source.getFullYear();
    const month = leftPad(source.getMonth() + 1);
    const day = leftPad(source.getDate());
    return [year, month, day].join(delimiter);
  }

  /**
   *
   * @param {Date} source
   * @param {String} delimiter
   */
  function toStringByHourFormatting(source, delimiter = ":") {
    const hour = leftPad(source.getHours());
    const min = leftPad(source.getMinutes());

    return [hour, min].join(delimiter);
  }

  // HTML 태그 포맷
  const deleteStyle = useDeleteStyle();

  if (isLoading) return <Loading />;

  return (
    <Wrapper>
      {isSuccess && (
        <>
          <TopContainer>
            {/* Top 컨텐츠들 */}
            {newsData?.content[0] &&
              newsData.content.slice(0, 1).map((v) => (
                <TopFirstBox onClick={() => openNewsModal(v.id)} key={v.id}>
                  <TopImgBox>
                    <img loading="lazy" src={v.img_path} alt="" />
                  </TopImgBox>
                  <TextBox>
                    <span>{v.title}</span>
                    <span dangerouslySetInnerHTML={{ __html: deleteStyle(v.content) }}></span>
                    <span>
                      <div>{toStringByFormatting(new Date(v.date))}</div>
                      <div>
                        <img
                          loading="lazy"
                          src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/fd6a9ee0NewsEvents_2.svg"
                          alt=""
                        />
                      </div>
                      <div>{toStringByHourFormatting(new Date(v.date))}</div>
                      <div>
                        <img
                          loading="lazy"
                          src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/fd6a9ee0NewsEvents_2.svg"
                          alt=""
                        />
                      </div>
                      <div>{v.region}</div>
                    </span>
                  </TextBox>
                </TopFirstBox>
              ))}
            <TopSecondBox>
              {newsData?.content[1] &&
                newsData.content.slice(1, 3).map((v) => (
                  <ContentBox key={v.id} onClick={() => openNewsModal(v.id)}>
                    <ImgBox1 loading="lazy">
                      <img loading="lazy" src={v.img_path} alt="" />
                    </ImgBox1>
                    <TextBox2>
                      <span>{v.title}</span>
                      <span dangerouslySetInnerHTML={{ __html: deleteStyle(v.content) }}></span>
                      <span>
                        <div>{toStringByFormatting(new Date(v.date))}</div>
                        <div>
                          <img
                            loading="lazy"
                            src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/fd6a9ee0NewsEvents_2.svg"
                            alt=""
                          />
                        </div>
                        <div>{toStringByHourFormatting(new Date(v.date))}</div>
                        <div>
                          <img
                            loading="lazy"
                            src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/fd6a9ee0NewsEvents_2.svg"
                            alt=""
                          />
                        </div>
                        <div>{v.region}</div>
                      </span>
                    </TextBox2>
                  </ContentBox>
                ))}
            </TopSecondBox>
          </TopContainer>
          {/* Bottom 컨텐츠들 */}
          <BottomContainer>
            {newsData?.content[3] &&
              newsData.content.slice(3).map((v) => (
                <ContentBox key={v.id} onClick={() => openNewsModal(v.id)}>
                  <ImgBox1 loading="lazy">
                    <img loading="lazy" src={v.img_path} alt="" />
                  </ImgBox1>
                  <TextBox2>
                    <span>{v.title}</span>
                    <span dangerouslySetInnerHTML={{ __html: deleteStyle(v.content) }}></span>
                    <span>
                      <div>{toStringByFormatting(new Date(v.date))}</div>
                      <div>
                        <img
                          loading="lazy"
                          src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/fd6a9ee0NewsEvents_2.svg"
                          alt=""
                        />
                      </div>
                      <div>{toStringByHourFormatting(new Date(v.date))}</div>
                      <div>
                        <img
                          loading="lazy"
                          src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/fd6a9ee0NewsEvents_2.svg"
                          alt=""
                        />
                      </div>
                      <div>{v.region}</div>
                    </span>
                  </TextBox2>
                </ContentBox>
              ))}
          </BottomContainer>
          {/* Pagination */}

          <Pagination totalPages={newsData.totalPages} />
        </>
      )}
    </Wrapper>
  );
};

export default Com2;
